export const redeemOfferData = 'redeemOfferData';

export const pricingFields = [redeemOfferData];
